export default "__VITE_ASSET__BSHrRrFP__"